<ng-container *ngIf="mySpaces$ | async as mySpaces">
  <p-select
    *ngIf="mySpaces.length > 1"
    [options]="mySpaces"
    [(ngModel)]="activeSpace"
    [styleClass]="'space-list'"
    [appendTo]="'body'"
    [scrollHeight]="'200px'"
    [dropdownIcon]="'pi pi-angle-down'"
    [showClear]="false"
    [autoDisplayFirst]="false"
    (onChange)="onSpaceChange($event.value)"
  >
    <ng-template let-item pTemplate="item">
      <a [href]="item.fullUrl" style="text-decoration: none; color: inherit">
        <div>
          <i
            class="mr-4 color-primary"
            [ngClass]="item.icon | getIconCssClass"
          ></i>
          <span class="mr-4"> {{ item.name | propertyTranslator }}</span>
        </div>
      </a>
    </ng-template>
    <ng-template let-item pTemplate="selectedItem">
      <div class="sel-items flex items-center">
        <i
          class="mr-4 color-primary"
          [ngClass]="item.icon | getIconCssClass"
        ></i>
        <span class="mr-4 font-bold">
          {{ item.name | propertyTranslator }}</span
        >
      </div>
    </ng-template>
  </p-select>
</ng-container>
